import { constants, typographyStyles } from "@newsela/angelou";
import type { CSSObject } from "@emotion/react";
const { ui } = constants.colors;
const { heading5Obj } = typographyStyles;

export const headingCss: CSSObject = {
  ...heading5Obj,
  margin: 0,
  fontWeight: 700,
  color: ui.neutral[600],
  paddingRight: ".5em",
};

export const inputWrapperCss: CSSObject = {
  display: "flex",
  label: { ...headingCss },
  marginBottom: "20px",
};

export const inputCss: CSSObject = {
  height: "2rem",
};

export const loadingWrapperCss: CSSObject = {
  ...inputCss,
  display: "flex",
  flexDirection: "column",
};
